import { Culture } from '../../types';

export const cherokee: Culture = {
  name: 'Cherokee',
  languageFamily: 'Iroquoian',
  terms: [
    {
      word: 'ᎠᎹᎦᎵ (Amadahi)',
      phonetic: 'ah-mah-dah-hee',
      description: 'Cherokee word for "forest" or "woods."'
    },
    {
      word: 'ᎠᏂᏬᏂᎯᏳ (Aniyvwiya)',
      phonetic: 'ah-nee-yuh-wee-yah',
      description: 'Cherokee word for "the real people," referring to the Cherokee themselves.'
    },
    {
      word: 'ᎡᎶᎯᏛᎢ (Elohi)',
      phonetic: 'eh-loh-hee',
      description: 'Cherokee word meaning "earth" or "world."'
    },
    {
      word: 'Osiyo',
      phonetic: 'oh-see-yoh',
      description: 'A Cherokee greeting meaning "hello."'
    },
    {
      word: 'ᏍᎦᏯ (Sgaya)',
      phonetic: 'sgah-yah',
      description: 'Cherokee word for "man."'
    }
  ]
};